namespace GeniuzPOS.CustomReport {
    export class ReportCustomerSurveyTranDtColumns {
        static columnsKey = 'CustomReport.ReportCustomerSurveyTranDt';
    }
}
